import { ModifierGroupOverride, Product } from '@interfaces/product/1.0';
import { Observable } from 'rxjs';

export abstract class AbstractProductService {
  abstract getProducts(brandId: string): Observable<Product[]>;

  abstract create(product: Partial<Product>, brandId: string): Observable<any>;

  abstract save(catalogEntryId: string, product: Product, remove?: string[]): Observable<any>;

  abstract saveOverrides(
    catalogEntryId: string,
    overrides: ModifierGroupOverride[],
  ): Observable<Product>;
}
